import React, { useState, useEffect } from 'react';
import '../App.css';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'reactstrap';
import user from '../assets/user.png';
import MyStorage from './util/storage';
import MyLoader from './util/loader';
import { ToastContainer } from 'react-toastify';

const HomeSubscriptions = () => {
    const history = useHistory();

    const location = useLocation();
    const users = location.state.users;

    const [models, setModels] = useState(users);
    const [loader, setLoader] = useState(false);

    // load data
    useEffect(() => {
        //
    }, []);

    const getProfilePhoto = (model) => {
        if (MyStorage.getFileUrls() == null || model.photo == null || model.photo === '') {
            return user
        }
        else {
            if (model.photo.includes('http')) {
                return model.photo
            }
            return MyStorage.getFileUrls().User + model.photo
        }
    };

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Subscribers
                </div>
            </div>
            <div style={{ marginTop: 30 }}></div>
            {models.map((model, index) => {
                if (model.type === 'admin') {
                    return null
                }
                let className = index % 2 !== 0 ? 'projects-itembar' : 'projects-itembar-colored'
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className={className} style={{ marginTop: 0 }}>
                            <div className='projects-item-photo'>
                                <img src={getProfilePhoto(model)} style={{ padding: 1, width: 70, height: 70 }} />
                            </div>
                            <div className='projects-item-cat' style={{}}>
                                <div style={{ fontSize: 16, color: 'blue' }}>#{model.id}</div>
                                <div style={{ fontSize: 16 }}>{model.fname} {model.lname}</div>
                                <div style={{ fontSize: 16 }}>{model.email}</div>
                                {/* <div style={{ color: 'green' }}>{model.subscriber === '1' ? 'Member' : 'Non-Member'}</div> */}
                                {model.status === 'suspended' ?
                                    <div style={{ color: 'red' }}>Suspended</div>
                                    :
                                    null
                                }
                            </div>

                            <div className='projects-item-cat' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    className='btn-block btn-submit'
                                    style={{ width: 150, fontSize: 16 }}
                                    onClick={() => {
                                        console.log('click');
                                        history.push({
                                            pathname: '/user-details',
                                            state: { user: model }
                                        })
                                    }}>
                                    View Details
                                </Button>
                            </div>

                        </div>

                    </div>
                );
            })}
            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default HomeSubscriptions;